// extracted by mini-css-extract-plugin
export default {"table":"ArtistOrders_table__kMqSW","icons":"ArtistOrders_icons__e8wVU","pending":"ArtistOrders_pending__2WVUe","delivered":"ArtistOrders_delivered__E9Ag6"};